module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_04-a54d44f144b253e9b76edbb5f2d4cce4.jpg";